import { formatLayer } from '../layers/helpers'
import { formatMedia } from '../media/helpers'
import { DateUtils } from '../../../utils'

/**
 * Formats playlist data
 * @param {Object} raw
 */
const formatPlaylist = ({ date_end, date_start, layers, media, ...raw }) => {
    return {
        ...raw,
        date_end: date_end && DateUtils.UTCDateToTimestamp(date_start),
        date_start: date_start && DateUtils.UTCDateToTimestamp(date_start),
        layers: layers ? layers.map(formatLayer) : [],
        media: media ? media.map(formatMedia) : [],
    }
}

// eslint-disable-next-line import/prefer-default-export
export { formatPlaylist }
